module.exports = __webpack_public_path__ + "static/media/document-thumbnail-CBRimg2.00c35bc8.png";